import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import {
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper";
import {
  errorToastify,
  successToastify,
} from "../../../Components/Common/Toaster";
import { useNavigate } from "react-router-dom";

function* loginUser({ payload: { user, history } }) {
  try {
    if (user) {
      const response = yield call(postJwtLogin, {
        phone_number: user.email,
        password: user.password,
      });
      console.log("login response", response);
      if (response.mStatus === 200) {
        sessionStorage.setItem("authUser", JSON.stringify(response));

        yield put(loginSuccess(response));
        history("/customer-list");
        successToastify("Login Successful");
      } else {
        // Handle API errors
        const errorMessage = response.message || "Authentication failed";
        if (response.statusCode === 402) {
          history("/credential-error");
        }
        if (response.statusCode === 403) {
          history("/account-expired");
        }
        yield put(apiError(errorMessage));
        // errorToastify("Invalid Credential!, Please Try Again.");
        // yield put(apiError(response));
      }
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* logoutUser() {
  try {
    sessionStorage.removeItem("authUser");
    sessionStorage.removeItem("user_name");
    sessionStorage.removeItem("phone_number");
    sessionStorage.removeItem("user_type");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user_id");
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      // const fireBaseBackend = getFirebaseBackend();
      // const response = yield call(fireBaseBackend.logout);
      // yield put(logoutUserSuccess(LOGOUT_USER, response));
    } else {
      yield put(logoutUserSuccess(true));
    }
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      // const fireBaseBackend = getFirebaseBackend();
      // const response = yield call(fireBaseBackend.socialLoginUser, type);
      // if (response) {
      //   history("/dashboard");
      // } else {
      //   history("/login");
      // }
      // sessionStorage.setItem("authUser", JSON.stringify(response));
      // yield put(loginSuccess(response));
    } else {
      const response = yield call(postSocialLogin, data);
      sessionStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    }
    history("/dashboard");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
